export default __webpack_public_path__ + "beaf74ac7bf3b019ca0497987de7a11a.png";